var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWishlistIcon = function SvgWishlistIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 42 42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1946"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    stroke: "#d0d5db",
    "data-name": "Ellipse 57"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1f2a3b",
    d: "M25.219 12.25A5.791 5.791 0 0 0 21 14.081a5.781 5.781 0 0 0-10 3.95c0 5.756 9.284 11.406 9.687 11.628a.625.625 0 0 0 .644 0C21.716 29.437 31 23.788 31 18.031a5.787 5.787 0 0 0-5.781-5.781M21 28.387c-1.616-1.031-8.75-5.85-8.75-10.356a4.531 4.531 0 0 1 8.238-2.6.625.625 0 0 0 1.022 0 4.531 4.531 0 0 1 8.241 2.6C29.75 22.534 22.616 27.35 21 28.387"
  }))));
};
export default SvgWishlistIcon;